(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/views/betslip/betslip-payoptions.js') >= 0) return;  svs.modules.push('/modules/maltipset/views/betslip/betslip-payoptions.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.maltipset=_svs.maltipset||{};
_svs.maltipset.templates=_svs.maltipset.templates||{};
svs.maltipset.templates.betslip_payoptions = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "<span>Visa översikt av spelet</span>";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"padding\">\n"
    + ((stack1 = (helpers.ui || (depth0 && depth0.ui) || helpers.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"button",{"name":"ui","hash":{"transparent":true,"icon-position":"right","icon":"viewsummary","block":true,"size":300,"class":"betslip-overview","id":"betslip-overview"},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n</div>\n\n<div class=\"sportkryss\"></div>\n\n<div class=\"weeks\"></div>\n";
},"useData":true});
Handlebars.partials['svs-maltipset-betslip_payoptions'] = svs.maltipset.templates.betslip_payoptions;
})(svs, Handlebars);

 })(window);